import React from 'react'

const LoadingPage = () => {
    return ( 
        <div className='loading-container'>
            <div className='loading'></div>
        </div>
    )
}

export default LoadingPage
